import classNames from 'classnames';
import { useState } from 'react';
import { default as TooltipComponent } from '../core/Tooltip';
import './index.less';

const defaultRatingRange = [1, 2, 3, 4, 5];
const defaultRating = 0;

const HeartRating = ({
    title,
    rating = defaultRating,
    ratingRange = defaultRatingRange,
    onClick = () => { },
    size = 'sm',
    tooltip,
    children,
    disabled = false,
}) => {
    const [hoveredRating, setHoveredRating] = useState(null);

    const classes = [];
    if (new Set(['sm', 'md']).has(size)) {
        classes.push(`heart-block-${size}`);
    }

    const Tooltip = () => {
        if (!tooltip) return null;
        return <TooltipComponent title={tooltip}><span className='icon-svg-help-circle'></span></TooltipComponent>;
    };

    const handleMouseEnter = (value) => {
        if (!disabled) {
            setHoveredRating(value);
        }
    };

    const handleMouseLeave = () => {
        setHoveredRating(null);
    };

    return (
        <div className={classNames('heart-block', classes)}>
            <div className='bold'>{title} <Tooltip /></div>
            <div className={'experience-indicator'}
                data-score={rating}
                data-size={size}
                onMouseLeave={handleMouseLeave}>
                {ratingRange.map((value) => (
                    <a key={value}
                        className='experience-indicator-heart'
                        data-rating={value}
                        onClick={() => onClick(value)}
                        onMouseEnter={() => handleMouseEnter(value)}>
                        <span className={classNames('icon-svg-heart rating-heart', {
                            active: hoveredRating !== null ? hoveredRating >= value : rating >= value,
                            disabled: disabled,
                        })}>
                        </span>
                    </a>
                ))}
                {children}
            </div>
        </div>
    );
};

export default HeartRating;
